import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { required } from '@/utils/validators';

export default {
  name: 'RegisterForm',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      form: {
        name: '',
        scale: null,
      },
      organizationType: 'company',
    };
  },
  computed: {
    ...mapState('user', {
      registerForm: ({ registerForm }) => registerForm,
      registering: ({ registering }) => registering,
    }),
    organizationTypes() {
      return [
        {
          text: '公司行號',
          value: 'company',
        },
        {
          text: '私人社團/其他組織',
          value: 'personal',
        },
      ];
    },
    scales() {
      return [
        {
          text: '新創(1-19人)',
          value: 1,
        },
        {
          text: '小型(20-50人) ',
          value: 2,
        },
        {
          text: '中型(51-100人)',
          value: 3,
        },
        {
          text: '大型(101以上)',
          value: 4,
        },
      ];
    },
  },
  methods: {
    ...mapActions('user', {
      setRegisterForm: 'SET_USER_REGISTER_FORM',
      userRegister: 'USER_REGISTER',
    }),
    async register() {
      const valid = await this.v$.$validate();
      if (!valid) return;

      this.setRegisterForm({
        ...this.registerForm,
        ...this.form,
        ...{
          type: this.organizationType,
        },
      });
      this.$emit('next');
    },
    getErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return this.v$.form?.[field]?.$errors?.length;
    },
  },
  validations() {
    return {
      form: {
        name: { required: required('組織名稱') },
        scale: { required: required('組織規模') },
      },
    };
  },
};
